<template>
  <div>
    <Panel module="Estoque" title="Case" :showFilter="false" :showSearch="true" :showButtons="true">
      <div slot="content-buttons">
        <Button _key="btnCaseCreate" title="Case" classIcon="fas fa-plus-circle" type="primary" size="small"
          :clicked="openCreateModal" />
      </div>
      <div slot="content-main">
          <TableTotalRecords :totalRecords="totalRecords" />

          <Loading v-if="loading" type="line" :center="false" />

          <div v-if="!loading && cases.length === 0" class="case-list-empty">
            <i class="fa-solid fa-briefcase"></i>
            <span>Nenhum registro encontrado!</span>
          </div>

          <div v-if="cases.length > 0" class="case-list-grid">
            <CaseCard v-for="caseObj in cases" :key="caseObj.id" :caseData="caseObj" @open="navigateToCase"
              @edit="openEditModal" @delete="deleteCase" />
          </div>

          <div class="case-list-more" v-if="hasMore && !loading">
            <Button _key="btnCaseLoadMore" title="Carregar mais..." type="info" classIcon="fas fa-redo" size="small"
              :clicked="loadMore" />
          </div>
      </div>
    </Panel>

    <Modal title="Case" :width="800" :height="750" v-show="showModal('caseForm')">
      <CaseForm />
    </Modal>
  </div>
</template>

<script>
import Panel from "@/ui/layout/Panel";
import Button from "@/ui/forms/Button";
import Modal from "@/ui/forms/Modal";
import Loading from "@/ui/shared/Loading.vue";
import TableTotalRecords from "@/ui/shared/TableTotalRecords.vue";

import CaseCard from "../components/case/CaseCard.vue";
import CaseForm from "../components/case/CaseForm.vue";

import CaseService from "../services/case.service";

import { mapGetters, mapMutations, mapState } from "vuex";

export default {
  name: "CaseList",
  components: { Panel, Button, Modal, Loading, TableTotalRecords, CaseCard, CaseForm },
  data() {
    return {
      loading: true,
      cases: [],
      totalRecords: 0,
      baseParams: {
        search: "",
        filter: "",
        currentPage: 1,
        totalPerPage: 20,
      },
    };
  },
  mounted() {
    this.removeLoading(["panel"]);
    this.getAll();
  },
  computed: {
    ...mapGetters("generic", ["showModal", "event"]),
    ...mapState("generic", ["search", "executedSearch", "clearedSearch"]),
    hasMore() {
      return this.cases.length < this.totalRecords;
    },
  },
  methods: {
    ...mapMutations("generic", ["addEvent", "openModal", "removeLoading"]),
    async getAll() {
      this.loading = true;
      try {
        const response = await CaseService.getAll({ ...this.baseParams });
        const content = response.content;
        this.totalRecords = content.totalRecords;
        this.cases =
          this.baseParams.currentPage === 1 ? content.data : [...this.cases, ...content.data];
      } finally {
        this.loading = false;
        this.removeLoading(["btnCaseLoadMore"]);
      }
    },
    loadMore() {
      this.baseParams.currentPage++;
      this.getAll();
    },
    openCreateModal() {
      this.openModal("caseForm");
      this.addEvent({ name: "caseCreate" });
      this.removeLoading(["btnCaseCreate"]);
    },
    openEditModal(caseObj) {
      this.openModal("caseForm");
      this.addEvent({ name: "caseUpdate", data: caseObj });
    },
    async deleteCase(caseObj) {
      await CaseService.remove([caseObj.id]);
      this.baseParams.currentPage = 1;
      this.getAll();
    },
    navigateToCase(caseObj) {
      this.$router.push({ name: "caseUpdate", params: { id: caseObj.id } });
    },
  },
  watch: {
    executedSearch() {
      this.baseParams.search = this.search.content;
      if (this.search.filter.id) this.baseParams.filter = this.search.filter.id;
      this.baseParams.currentPage = 1;
      this.getAll();
    },
    clearedSearch() {
      this.baseParams.search = "";
      this.baseParams.filter = "";
      this.baseParams.currentPage = 1;
      this.getAll();
    },
    event: {
      handler(event) {
        if (event.name === "caseCreated" || event.name === "caseUpdated") {
          this.baseParams.currentPage = 1;
          this.getAll();
        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.case-list-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 48px 0;
  color: var(--text-muted);
  font-size: 14px;
}

.case-list-empty i {
  font-size: 40px;
  color: var(--color-brand-light);
}

.case-list-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.case-list-more {
  display: flex;
  justify-content: center;
  margin-top: 24px;
}
</style>
